import { Component, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService, HTTPService } from 'app/services';
import { EventEmitter } from 'events';
import { CookieService } from 'ngx-cookie';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-subscription-expiry-modal',
  templateUrl: './subscription-expiry-modal.component.html',
  styleUrls: ['./subscription-expiry-modal.component.scss'],
})
export class SubscriptionExpiryModalComponent implements OnInit {
  isSubscriptionExpired: boolean = false;

  // title of modal
  get title() {
    return !this.isSubscriptionExpired ? 'Subscribe now' : 'Your trial has expired!';
  }

  // description of modal
  get description() {
    return !this.isSubscriptionExpired
      ? 'One of our representatives will soon get in touch with you. Kindly provide your preferred contact information.'
      : 'Subscribe now or Request an extension to continue using AutoLeap';
  }

  processing: boolean = false;
  contactInfo = {
    name: '',
    email: '',
    phone: '',
  };

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private helperService: HelperService,
    private httpService: HTTPService,
    private cookieService: CookieService,
    private router: Router
  ) {}

  ngOnInit() {
    // check whether to open expiry or subscription modal
    this.isSubscriptionExpired = this.dialogConfig.data && this.dialogConfig.data.isSubscriptionExpired;

    this.httpService.getUser(this.helperService.getCompany().userId).then(
      (user) => {
        this.contactInfo.email = user.userName;
        this.contactInfo.name = `${user.firstName} ${user.lastName}`;
        this.contactInfo.phone = user.otherUserName;
      },
      (err) => console.error(err)
    );
  }

  /**
   * Submit subscription request
   */
  submitSubscriptionRequest() {
    this.processing = true;
    this.httpService
      .subscriptionRequest(this.helperService.getCompany().companyId, this.contactInfo)
      .then(() => {
        this.helperService.showToaster('success', 'Subscription request submitted');
        if (!this.isSubscriptionExpired) this.close(true, true);
      })
      .catch((error) => this.helperService.showToaster('error', error))
      .finally(() => (this.processing = false));
  }

  /**
   * Submit trial Extension request
   */
  submitTrialExtensionRequest() {
    this.processing = true;
    this.httpService
      .trialExtensionRequest(this.helperService.getCompany().companyId, this.contactInfo)
      .then(() => {
        this.helperService.showToaster('success', 'Extension request submitted');
        if (!this.isSubscriptionExpired) this.close(true, false);
      })
      .catch((error) => this.helperService.showToaster('error', error))
      .finally(() => (this.processing = false));
  }

  /**
   * Close modal and send data back to parent component
   *
   * @param isSuccess
   * @param isSubscriptionRequested
   */
  close(isSuccess: boolean, isSubscriptionRequested?: boolean) {
    this.dynamicDialogRef.close({ isSuccess, isSubscriptionRequested });
  }

  logout() {
    this.helperService.logout();
  }
}
